import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "@material-ui/core/Modal";
import AccountForm from "./AccountForm";
import klerData from "../../apis/klerData";
import zohoData from "../../apis/zohoData";
import * as actions from "../../actions";
import _ from "lodash";

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      open: false,
      renderForm: [],
      user: this.props.auth.googleId,
      createZohoAccount: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
  }

  componentDidMount() {
    this.props.fetchSubscription(this.props.auth.googleId);
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleCloseReload = () => {
    this.setState({ open: false });
    this.props.fetchSubscription(this.props.auth.googleId);
  };

  checkBusinessName = () => {
    if (
      localStorage.getItem("UserBusiness") === "" ||
      localStorage.getItem("UserBusiness") === null ||
      !localStorage.getItem("UserBusiness")
    ) {
      this.renderForm();
      this.setState({ open: true });
      console.log(this.props);
    }
  };

  renderForm = () => {
    let subscription = [];
    let form = [];
    if (this.props.subscription && this.props.subscription[0]) {
      subscription = this.props.subscription[0];
      form = (
        <div>
          <AccountForm
            Oid={subscription.Oid}
            data={subscription}
            UserId={this.state.user}
            handleCloseReload={this.handleCloseReload}
          />
        </div>
      );
    } else {
      form = (
        <div>
          <AccountForm
            Oid=""
            data=""
            UserId={this.state.user}
            handleCloseReload={this.handleCloseReload}
          />
        </div>
      );
    }
    return form;
  };

  checkZohoAccount = _.memoize(() => {
    if (this.props.subscription[0].ZohoId) {
      // console.log("ZOHO ID FOUND");
    } else {
      console.log("ZOHO ID DOES NOT EXIST");

      console.log("CREATE ZOHO ACCOUNT");
      let createAccountData = this.props.subscription[0];
      console.log(createAccountData);
      zohoData
        .post(`/customers`, JSON.stringify(createAccountData))
        .then(result => {
          //console.log(result);
          //this.getUpdatedZohoCustomers(createAccountData);
        })
        .catch(error => {
          console.log(error);
          //this.getUpdatedZohoCustomers(createAccountData);
        });
    }
  });

  getUpdatedZohoCustomers = _.memoize(sourceData => {
    if (this.props.subscription[0].ZohoId) {
      // console.log("ZOHO ID FOUND");
    } else {
      // console.log("GET UPDATE CUSTOMER LIST");
      zohoData
        .get(`/customers`)
        .then(result => {
          // console.log(result.data);
          this.getNewZohoId(result.data, sourceData);
        })
        .catch(error => {
          console.log(error);
        });
    }
  });

  getNewZohoId = (data, sourceData) => {
    //console.log("GET ZOHO ID");
    // console.log(data);
    function findNewId(item) {
      if (
        item.first_name === sourceData.FirstName &&
        item.last_name === sourceData.LastName &&
        item.company_name === sourceData.Business
      ) {
        //console.log(item.customer_id);
        let updatedata = "";
        updatedata = updatedata + "{";
        updatedata = updatedata + 'ZohoId: "' + item.customer_id + '"';
        updatedata = updatedata + "}";
        // console.log(updatedata);
        //console.log(sourceData.Oid);
        klerData
          .put(`/Subscription(${parseInt(sourceData.Oid)})`, updatedata)
          .then(result => {
            // console.log("ZOHO ID SAVED");
          })
          .catch(error => console.log(error));
      }
    }
    data.forEach(findNewId);
  };

  render() {
    // ***************************
    // EDIT GROUP FUNCTIONALITY
    const handleEditAccount = e => {
      this.setState({
        open: true
      });
    };

    const alert = value => {
      let message = "";
      if (!value) {
        message = (
          <p className="alert">
            Thank you for your interest in KLER Menus. Please enter your{" "}
            <u>name</u> and <u>business</u> to start your 60-day trial.
          </p>
        );
      }
      if (value) {
        message = <p className="alert">Enjoy your 60-day trial.</p>;
      }
      return message;
    };

    function getModalStyle() {
      const top = 50;
      const left = 50;

      return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        position: `absolute`,
        width: 400,
        maxWidth: `90%`,
        backgroundColor: "#efefef",
        border: "2px solid #000",
        padding: 10,
        color: "#000000"
      };
    }

    let account = "";
    let subscription = [];
    if (this.props.subscription && this.props.subscription[0]) {
      this.checkZohoAccount();
      this.getUpdatedZohoCustomers(this.props.subscription[0]);
      // console.log("RENDER");
      subscription = this.props.subscription[0];
      account = (
        <div>
          {alert(subscription.Business)}
          <div>
            {subscription.FirstName} {subscription.LastName}
          </div>
          <div>{subscription.Business}</div>
          <div>{subscription.SubscriptionId}</div>
          <div>{subscription.Email}</div>
          <div>{subscription.Phone}</div>
        </div>
      );
    } else {
      account = <div>{alert()}</div>;
    }
    return (
      <div className="dashboard-component" style={{ textAlign: "center" }}>
        <div className="row">
          <div className="col s12 m6 offset-m3">
            <div className="card grey darken-5">
              <div className="card-action">
                <span className="card-title">My Account</span>
              </div>
              <div className="card-content white-text">
                <div className="row">
                  <div className="col s12 txt-center">{account}</div>
                </div>
              </div>
              <div className="card-action">
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleEditAccount}
                >
                  Edit Account
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          className="card-modal"
        >
          <div style={getModalStyle()}>{this.renderForm()}</div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    subscription: state.subscription,
    zohoCustomers: state.zohoCustomers
  };
}

export default connect(
  mapStateToProps,
  actions
)(Account);
